module.exports = __webpack_public_path__ + "media/images/pricing/individual-4f25f12d656599cf669f13fd6dea487a.png";